import type { RSUAsset, ShareAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateShareBalance, calculateStocksTotalBalance } from "./balance";
import { calculateRSUBalance, calculateRSUTotalBalance } from "./rsu";

export const calculateStocksPartInPortfolio = (
  userProduct: ShareAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.stocksData || [];
  const totalBalance = calculateStocksTotalBalance(
    userProduct,
    true,
    cashCurrency,
    baseCurrency
  );
  const { balanceInBaseCurrency: shareBalances } =
    calculateShareBalance(userProduct);

  return stocks.map((_, index) => {
    const shareBalance = shareBalances?.[index] || 0;

    if (Number(totalBalance) === 0) return 0;
    return shareBalance / totalBalance;
  });
};

export const calculateRSUPartInPortfolio = (
  userProduct: RSUAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.rsuData || [];
  const totalBalance = calculateRSUTotalBalance(userProduct);
  const { balanceInBaseCurrency: shareBalances } =
    calculateRSUBalance(userProduct);

  return stocks.map((_, index) => {
    const shareBalance = shareBalances?.[index] || 0;

    if (Number(totalBalance) === 0) return 0;
    return shareBalance / totalBalance;
  });
};

export const calculateOnlyStocksPortfolio = (
  userProduct: ShareAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.stocksData || [];
  const totalBalance = calculateStocksTotalBalance(
    userProduct,
    false,
    cashCurrency,
    baseCurrency
  );
  const { balanceInBaseCurrency: shareBalances } =
    calculateShareBalance(userProduct);

  return stocks.map((_, index) => {
    const shareBalance = shareBalances?.[index] || 0;

    if (Number(totalBalance) === 0) return 0;
    return shareBalance / totalBalance;
  });
};



export const calculateOnlyRSUsPortfolio = (
  userProduct: RSUAsset,
  cashCurrency: Fiat,
  baseCurrency: Fiat
) => {
  const stocks = userProduct?.rsuData || [];
  const totalBalance = calculateRSUTotalBalance(userProduct);
  const { balanceInBaseCurrency: shareBalances } =
    calculateRSUBalance(userProduct);

  return stocks.map((_, index) => {
    const shareBalance = shareBalances?.[index] || 0;

    if (Number(totalBalance) === 0) return 0;
    return shareBalance / totalBalance;
  });
};
